import type { IconDef } from '../types';

export const liquor: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M19.0457 6.33C18.8557 6.12 18.5857 6 18.2957 6H5.00566C4.71566 6 4.44566 6.12 4.25566 6.33C4.06566 6.55 3.97566 6.83 4.00566 7.11L5.40566 19.2C5.52566 20.21 6.37566 20.97 7.39566 20.97H15.9157C16.9357 20.97 17.7857 20.21 17.9057 19.2L19.2957 7.11C19.3257 6.83 19.2357 6.54 19.0457 6.33ZM17.4157 8.24L16.4857 14.07H6.81566L6.36566 7.75L17.4057 8.23L17.4157 8.24ZM15.6757 19.15L7.15566 18.78L6.96566 16.08H16.1657L15.6757 19.15Z',
    },
  ],
};
